//
//
//
//
//
//
//

export default {
    name:'exclusiveProgress',
    props: {
        progress:0
    }
    
}



// WEBPACK FOOTER //
// ./src/components/operation/exclusiveProgress.vue